import type { ReactElement } from 'react';
import { Button } from '@/components/atoms/button';

type Props = {
  onRetry: () => void;
};

export function SearchErrorState({ onRetry }: Props): ReactElement {
  return (
    <div
      role="alert"
      className="flex flex-1 flex-col items-center justify-center px-6 py-10 text-center"
    >
      <h2 className="font-display text-lg font-semibold tracking-tight text-[var(--ink)]">
        Couldn&apos;t search the library
      </h2>
      <p className="mt-2 max-w-xs text-sm leading-relaxed text-[var(--ink-3)]">
        Please retry in a moment.
      </p>
      <div className="mt-6">
        <Button variant="primary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    </div>
  );
}
